// import React from "react";
// import styles from "./AIPlatform.module.css";
// import phoneImg from "../../../Images/AIPlatform_img.png";
// import { motion } from "framer-motion";

// export default function AIPlatform() {
//     return (
//         <section className={styles.wrapper}>
//             <motion.div
//                 className={styles.left}
//                 initial={{ opacity: 0, x: -40 }}
//                 whileInView={{ opacity: 1, x: 0 }}
//                 transition={{ duration: 0.6 }}
//             >
//                 <h2 className={styles.title}>Connect AI Across Platforms</h2>

//                 <p className={styles.subtitle}>
//                     Seamlessly integrate ToxBox AI with your website, mobile app, and
//                     booking engines.
//                 </p>

//                 <ul className={styles.list}>
//                     <li>API & plugin support</li>
//                     <li>API & plugin support</li>
//                     <li>Unified guest experience</li>
//                 </ul>

//                 <motion.button
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.97 }}
//                     className={styles.btn}
//                 >
//                     Integrate AI Now
//                 </motion.button>
//             </motion.div>

//             <motion.div
//                 className={styles.right}
//                 initial={{ opacity: 0, x: 40 }}
//                 whileInView={{ opacity: 1, x: 0 }}
//                 transition={{ duration: 0.6 }}
//             >
//                 <img src={phoneImg} alt="phone" className={styles.image} />
//             </motion.div>
//         </section>
//     );
// }



// Section.jsx
import React from "react";
import styles from "./AIPlatform.module.css";
import phoneImg from "../../../Images/AIPlatform_img.png"; // replace with real
import { motion } from "framer-motion";

export default function AIPlatform() {
    return (
        <section className={styles.wrapper}>
            {/* LEFT SIDE */}
            <motion.div
                className={styles.left}
                initial={{ opacity: 0, x: -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
            >
                <h2 className={styles.title}>Connect AI Across Platforms</h2>

                <p className={styles.subtitle}>
                    Seamlessly integrate ToxBox AI with your website, mobile app, and
                    booking engines.
                </p>

                <ul className={styles.list}>
                    <li>API & plugin support</li>
                    <li>API & plugin support</li>
                    <li>Unified guest experience</li>
                </ul>

                <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.97 }}
                    className={styles.btn}
                >
                    Integrate AI Now
                </motion.button>
            </motion.div>

            {/* RIGHT IMAGE SIDE */}
            <motion.div
                className={styles.right}
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
            >
                <img src={phoneImg} alt="phone" className={styles.image} />
            </motion.div>
        </section>
    );
}